import React from 'react'
import { ReactComponent as SuccessImage } from 'App/assets/success-welbe.svg'
import { Container, Content } from './Success.styles'

type SuccessProps = {
	customMessage?: string
}

export const SuccessInfo = ({ customMessage }: SuccessProps) => {
	return (
		<Container>
			<Content>
				<SuccessImage />
				<h4>{customMessage ?? 'Acción realizada con éxito.'}</h4>
			</Content>
		</Container>
	)
}
